import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-16">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-100 rounded-full mb-3">读者声音</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">读者热议</h2>
          <p className="mt-2 text-foreground-600 text-sm">来自黑料网站用户的真实评价与反馈</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((item) => (
            <div key={item.id} className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-colors duration-200">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-background-200 flex-shrink-0 overflow-hidden">
                  <img
                    src={item.avatar}
                    alt={item.author}
                    className="w-full h-full object-cover"
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="text-sm font-semibold text-foreground-900">{item.author}</h3>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                  </div>
                  <p className="mt-1.5 text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                  <div className="mt-3 flex items-center gap-3">
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-thumb-up-line text-xs"></i>
                      {item.likes}
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-chat-1-line text-xs"></i>
                      回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}